/** @format */

// methods
export function getIncome(request) {
  var incomes = [];
  var tempIncome = request.income * request.payoutFrequency;
  // convert to annual
  var currentAge = request.currentAge;
  var tempYear = request.startYear;
  while (tempYear <= request.incomeToLast) {
    // increasing income
    if (Number(tempYear % request.incomeGrowthFrequency) === 0)
      tempIncome =
        tempYear == 0 ? tempIncome : tempIncome * (1 + request.incomeGrowth);
    incomes.push(new IncomeView({ year: tempYear, income: tempIncome }));
    tempYear++;
  }
  return new GetIncomeCashFlowResponse({ incomes: incomes });
}
// models and types
var GetIncomeCashFlowRequest = /** @class */ (function() {
  function GetIncomeCashFlowRequest(init) {
    this.incomeLabel = "";
    this.keyIndex = 0;
    //
    this.income = 0;
    this.taxRate = 30;
    this.incomeToLast = 93;
    this.currentAge = 65;
    // linear growth
    this.incomeGrowth = 0;
    this.incomeGrowthFrequency = 1; // every 1 yr, 2 year, ...
    this.payoutFrequency = 12; //12 monthly, 3 quarterly, 1 annually
    this.startYear = 65;
    this.withdrawalStrategy = 0;
    Object.assign(this, init);
  }
  return GetIncomeCashFlowRequest;
})();
export { GetIncomeCashFlowRequest };
var GetContributionCashFlowRequest = /** @class */ (function() {
  function GetContributionCashFlowRequest(init) {
    this.contribution = 0;
    this.contributionToLast = 93;
    this.currentAge = 65;
    // linear growth
    this.contributionGrowth = 0;
    this.contributionGrowthFrequency = 1; // every 1 yr, 2 year, ...
    this.contributionFrequency = 12; //12 monthly, 3 quarterly, 1 annually
    this.contributionStartYear = 65;
    Object.assign(this, init);
  }
  return GetContributionCashFlowRequest;
})();
export { GetContributionCashFlowRequest };
var GetContributionCashFlowResponse = /** @class */ (function() {
  function GetContributionCashFlowResponse(init) {
    this.incomes = [];
    Object.assign(this, init);
  }
  return GetContributionCashFlowResponse;
})();
export { GetContributionCashFlowResponse };
var GetIncomeCashFlowResponse = /** @class */ (function() {
  function GetIncomeCashFlowResponse(init) {
    this.incomes = [];
    Object.assign(this, init);
  }
  return GetIncomeCashFlowResponse;
})();
export { GetIncomeCashFlowResponse };
var IncomeView = /** @class */ (function() {
  function IncomeView(init) {
    this.year = 0;
    this.income = 0;
    Object.assign(this, init);
  }
  return IncomeView;
})();
export { IncomeView };
